module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"may_select":"You may select up to {count} person for this plan"},"id":{"may_select":"Anda dapat memilih hingga {count} orang untuk paket ini"}}')
  delete Component.options._Ctor
}
